<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <material-card
        :title="$t('tractAnalysis')"
        :elevation="0"
        full-width>
          <v-tabs v-model="currentTab">
            <v-tab>
              <v-icon small class="mr-1">mdi-currency-usd</v-icon>{{$t('productCosts')}}
            </v-tab>
            <v-tab>
              <v-icon small class="mr-1">mdi-forest</v-icon>{{$t('standingTimber')}}
            </v-tab>
            <v-tab>
              <v-icon small class="mr-1">mdi-chart-arc</v-icon>{{$t('committed')}}
            </v-tab>
            <v-tab>
              <v-icon small class="mr-1">mdi-pine-tree-variant</v-icon>{{$t('products')}}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="currentTab" touchless>
            <v-tab-item>
              <ProductCosts @tract-category-selected="productCostCategorySelected"/>
            </v-tab-item>
            <v-tab-item>
              <StandingTimber/>
            </v-tab-item>
            <v-tab-item>
              <CommittedTimber/>
            </v-tab-item>
            <v-tab-item>
              <TimberPortfolio/>
            </v-tab-item>
          </v-tabs-items>

        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const Tabs = {
  ProductCosts: 0,
  StandingTimber: 1,
  CommittedTimber: 2,
  TimberPortfolio: 3
}

export default {
  name: 'TractAnalysis',

  components: {
    ProductCosts: () => import('@/components/tract/tract-analysis/ProductCosts.vue'),
    StandingTimber: () => import('@/components/tract/tract-analysis/StandingTimber.vue'),
    CommittedTimber: () => import('@/components/tract/tract-analysis/CommittedTimber.vue'),
    TimberPortfolio: () => import('@/components/tract/tract-analysis/TimberPortfolio.vue')
  },

  data: () => ({
    loading: false,
    currentTab: Tabs.ProductCosts,
    productCostCategory: 0
  }),

  methods: {
    productCostCategorySelected (category) {
      this.productCostCategory = category
    }
  }
}
</script>
